import React from 'react';
import Welcome from '../components/auth/Welcome';

export default function WelcomePage() {
  return <Welcome />;
}
